export const sluggify = (str: string, separator = "-") => {
  return str?.toLowerCase()?.replaceAll(" ", separator);
};
